import {DrawerMenuProps} from "tmwx-design-common";
import {getFieldError} from "../gui-common/appHelper";
import {RESPONSE_CODES, ResponseBase} from "../gui-common/redux/data";

export const getTitle = (pathname: string, t: any) => {
    // Kivételek
    if (
        pathname.includes("/atr/machines/details") ||
        pathname.includes("/atr/machines/params") ||
        pathname.includes("/atr/machines/commands") ||
        pathname.includes("/atr/machines/evadts") ||
        pathname.includes("/atr/machines/planogram")
    ) {
        return t("atr.machines.machines");
    }

    if (pathname.includes("/atr/master-data")) {
        return t("atr.masterData");
    }

    if (pathname.includes("/efe/control")) {
        return t("efe.control");
    }

    if (pathname.includes("/efe/efe")) {
        return t("efe.efeName");
    }

    if (pathname.includes("/efe/pod")) {
        return t("efe.measurementLoc");
    }

    if (pathname.includes("/efe/admin")) {
        return t("efe.admin");
    }

    switch (pathname) {
        case "/atr/dashboard":
            return t("dashboard");
        case "/atr/users":
            return t("portal.usersText");
        case "/atr/companies":
            return t("atr.companiesText");
        case "/atr/firmwares":
            return t("atr.firmwaresText");
        case "/atr/events":
            return t("events");
        case "/atr/machines":
            return t("atr.machines.machines");
        case "/atr/logs":
            return t("atr.logs.logs");
        case "/atr/report":
            return t("atr.report.report");
        case "/atr/eva-dts":
            return t("atr.evadts.evadts");
        case "/portal/dashboard":
            return t("dashboard");
        /* case '/portal/groups':
              return t('portal.groupsText') */
        case "/portal/roles":
            return t("portal.rolesText");
        case "/portal/users":
            return t("portal.usersText");
        case "/portal/events":
            return t("events");
        case "/efe/dashboard":
            return t("dashboard");
        // case "/efe/measurement-location":
        //     return t("efe.measurementLoc");
        // case "/efe/efe":
        //     return t("efe.efe");
        // case "/efe/measurement-data":
        //     return t("efe.measurementData");
        // case "/efe/logs":
        //     return t("efe.efeLog");
        // case "/efe/users":
        //     return t("portal.usersText");
        // case "/efe/providers":
        //     return t("efe.electricityProvider");
        // case "/efe/firmwares":
        //     return t("atr.firmwaresText");
        // case "/efe/events":
        //     return t("events");
    }
};

export const getSubtitle = (pathname: string, t: any) => {
    switch (pathname) {
        case "/atr/master-data/machine-categories":
            return t("atr.machineCategories.machineCategoriesText");
        case "/atr/master-data/machine-types":
            return t("atr.machineTypes.machineTypes");
        case "/atr/master-data/locations":
            return t("atr.locations.locationsText");
        case "/efe/pod/measurement-location":
            return t("efe.measurementLoc");
        case "/efe/pod/details":
            return t("efe.measurementLoc");
        case "/efe/pod/params":
            return t("efe.measurementLoc");
        case "/efe/pod/commands":
            return t("efe.measurementLoc");
        case "/efe/pod/metrics":
        case "/efe/pod/mqtt-messages":
            return t("efe.measurementLoc");
        // case "/efe/pod/measurement-loc-category":
        //     return t("efe.measurementLocCategory");
        case "/efe/pod/locations":
            return t("atr.locations.locationsText");
        case "/efe/control/metric-params":
            return t("efe.metricParams");
        case "/efe/control/register":
            return t("efe.rangeList.register");
        case "/efe/control/register-test":
            return t("efe.rangeList.register");
        case "/efe/control/python-script":
            return t("efe.pythonScript");
        case "/efe/efe/list":
            return t("efe.efe");
        case "/efe/efe/logs":
            return t("efe.efeLog");
        // case "/efe/efe/efe-type":
        //     return t("efe.efeType");
        case "/efe/efe/firmwares":
            return t("atr.firmwaresText");
        case "/efe/admin/users":
            return t("portal.usersText");
        case "/efe/admin/providers":
            return t("efe.electricityProvider");
    }
};

export const getMenuList = (
    subsystems: string[],
    hasRights: (rights: string[]) => boolean,
    t: any,
    path: string
) => {
    for (let i of getMenu(
        getActiveModuleName(path, subsystems).toLowerCase(),
        hasRights,
        t
    )) {
        if (path.includes(i.url) && i.menuItems) {
            return i.menuItems;
        }
    }

    return [];
};

export const getActiveModuleName = (
    pathname: string,
    subsystems: string[]
): any => {
    for (let s of subsystems) {
        if (pathname.includes(s.toLowerCase())) {
            return s.toLowerCase();
        }
    }
};

export const getMenu = (
    module: "atr" | "portal" | "efe",
    hasRights: (rights: string[]) => boolean,
    t: any
): DrawerMenuProps[] => {
    const atr: DrawerMenuProps[] = [
        {
            url: "/atr/dashboard",
            title: t("dashboard"),
            icon: "grid_view_outlined"
        },
        hasRights(["atr_machine_list"])
            ? {
                url: "/atr/machines",
                title: t("atr.machines.machines"),
                icon: "list"
            }
            : {},
        hasRights(["atr_machine_sale_list"])
            ? {
                url: "/atr/report",
                title: t("atr.report.report"),
                icon: "analytics_outlined"
            }
            : {},
        hasRights([
            "atr_machine_category_list",
            "atr_machine_type_list",
            "atr_location_list"
        ])
            ? {
                url: "/atr/master-data",
                title: t("atr.masterData"),
                icon: "data_table_outlined",
                menuItems: [
                    hasRights(["atr_machine_category_list"])
                        ? {
                            url: "/atr/master-data/machine-categories",
                            title: t("atr.machineCategories.machineCategoriesText"),
                            icon: "category_outlined"
                        }
                        : {},
                    hasRights(["atr_machine_type_list"])
                        ? {
                            url: "/atr/master-data/machine-types",
                            title: t("atr.machineTypes.machineTypes"),
                            icon: "format_align_left"
                        }
                        : {},
                    hasRights(["atr_location_list"])
                        ? {
                            url: "/atr/master-data/locations",
                            title: t("atr.locations.locationsText"),
                            icon: "location_on_outlined"
                        }
                        : {}
                ]
            }
            : {},
        hasRights(["atr_machine_log_list"])
            ? {
                url: "/atr/logs",
                title: t("atr.logs.logs"),
                icon: "logo_dev_outlined"
            }
            : {},
        hasRights(["atr_modul_users_read", "atr_company_users_read"])
            ? {
                url: "/atr/users",
                title: t("portal.usersText"),
                icon: "person_outlined"
            }
            : {},
        hasRights(["atr_modul_company_read"])
            ? {
                url: "/atr/companies",
                title: t("atr.companiesText"),
                icon: "cases_outlined"
            }
            : {},
        hasRights(["atr_firmware_list"])
            ? {
                url: "/atr/firmwares",
                title: t("atr.firmwaresText"),
                icon: "inventory_2_outlined"
            }
            : {},
        {
            url: "/atr/events",
            title: t("events"),
            icon: "event_note_outlined"
        }
    ];

    const portal: DrawerMenuProps[] = [
        {
            url: "/portal/dashboard",
            title: t("dashboard"),
            icon: "grid_view_outlined"
        },
        /* hasRights(['tmp_group_management']) ? {
                url: '/portal/groups',
                title: t('portal.groupsText'),
                icon: 'groups_2_outlined'
            } : {}, */
        hasRights(["portal_modul_roles_read"])
            ? {
                url: "/portal/roles",
                title: t("portal.rolesText"),
                icon: "badge_outlined"
            }
            : {},
        hasRights(["portal_modul_users_read"])
            ? {
                url: "/portal/users",
                title: t("portal.usersText"),
                icon: "person_outlined"
            }
            : {},
        {
            url: "/portal/events",
            title: t("events"),
            icon: "event_note_outlined"
        }
    ];

    const efe: DrawerMenuProps[] = [
        {
            url: "/efe/dashboard",
            title: t("dashboard"),
            icon: "grid_view_outlined"
        },
        hasRights([
            "efe_location_category_list",
            "efe_pod_list",
            "efe_location_list"
        ])
            ? {
                url: "/efe/pod",
                title: t("efe.measurementLoc"),
                icon: "data_table_outlined",
                menuItems: [
                        hasRights(["efe_pod_list"])
                            ? {
                                url: "/efe/pod/measurement-location",
                                title: t("efe.measurementLoc"),
                                icon: "list"
                            } : {},
                        // hasRights(["efe_location_category_list"])
                        //     ? {
                        //         url: "/efe/pod/measurement-loc-category",
                        //         title: t("efe.measurementLocCategory"),
                        //         icon: "category_outlined"
                        //     }
                        //     : {},
                        hasRights(["efe_location_list"])
                            ? {
                                url: "/efe/pod/locations",
                                title: t("atr.locations.locationsText"),
                                icon: "location_on_outlined"
                            }
                            : {}
                ]
        } : {},
        hasRights([
            "efe_metric_param_view",
            "efe_registers_view",
            "efe_python_script_view"
        ])
            ? {
                url: "/efe/control",
                title: t("efe.control"),
                icon: "settings_outlined",
                menuItems: [
                    hasRights(["efe_metric_param_view"])
                        ? {
                            url: "/efe/control/metric-params",
                            title: t("efe.metricParams"),
                            icon: "settings_applications_outlined",
                        }
                        : {},
                    // hasRights(["efe_registers_view"])
                    //     ? {
                    //         url: "/efe/control/register",
                    //         title: t("efe.rangeList.register"),
                    //         icon: "dataset_outlined",
                    //     }
                    //     : {},
                    hasRights(["efe_registers_view"])
                        ? {
                            url: "/efe/control/register",
                            title: t("efe.rangeList.register"),
                            icon: "dataset_outlined",
                        }
                        : {},
                    hasRights(["efe_python_script_view"])
                        ? {
                            url: "/efe/control/python-script",
                            title: t("efe.pythonScript"),
                            icon: "data_array",
                        }
                        : {},
                ]
        } : {},
        hasRights([
            "efe_efe_list",
            "efe_log_list",
            "efe_efe_type_list",
            "efe_firmware_list"
        ])
            ? {
                url: "/efe/efe",
                title: t("efe.efeName"),
                icon: "podcasts",
                menuItems: [
                    hasRights(["efe_efe_list"])
                        ? {
                            url: "/efe/efe/list",
                            title: t("efe.efe"),
                            icon: "podcasts"
                        } : {},
                    hasRights(["efe_log_list"])
                        ? {
                            url: "/efe/efe/logs",
                            title: t("efe.efeLog"),
                            icon: "logo_dev_outlined"
                        } : {},
                    // hasRights(["efe_efe_type_list"])
                    //     ? {
                    //         url: "/efe/efe/efe-type",
                    //         title: t("efe.efeType"),
                    //         icon: "format_align_left"
                    //     }
                    //     : {},
                    hasRights(["efe_firmware_list"])
                        ? {
                            url: "/efe/efe/firmwares",
                            title: t("atr.firmwaresText"),
                            icon: "inventory_2_outlined"
                        } : {},
                ]
            }
            : {},
        hasRights([
            "efe_modul_users_read",
            "efe_provider_users_read",
            "efe_modul_provider_read"
        ])
            ? {
                url: "/efe/admin",
                title: t("efe.admin"),
                icon: "data_table_outlined",
                menuItems: [
                    hasRights(["efe_modul_users_read", "efe_provider_users_read"])
                        ? {
                            url: "/efe/admin/users",
                            title: t("portal.usersText"),
                            icon: "person_outlined"
                        } : {},
                    hasRights(["efe_modul_provider_read"])
                        ? {
                            url: "/efe/admin/providers",
                            title: t("efe.electricityProvider"),
                            icon: "cases_outlined"
                        } : {},
                ]
            }
            : {},
        // {
        //     url: "/efe/events",
        //     title: t("events"),
        //     icon: "event_note_outlined"
        // }
    ];

    switch (module) {
        case "atr":
            return atr;
        case "portal":
            return portal;
        case "efe":
            return efe;
    }
};

export const getFieldErrorText = (
    field: string,
    serverError: ResponseBase | null,
    t: any
) => {
    const code = getFieldError(field, serverError);

    if (code) {
        switch (code) {
            case RESPONSE_CODES.RESERVED:
                return t("reservedFieldValue");
            case RESPONSE_CODES.EMPTY:
                return t("mandatoryField");
            case RESPONSE_CODES.TOO_LONG:
                return t("tooLong");
            case RESPONSE_CODES.INVALID_FORMAT:
                return t("fieldFormatError");
            case RESPONSE_CODES.INVALID_SYSTEM_ID:
                return t("invalidSystemId");
            case RESPONSE_CODES.INVALID_VERSION_NAME:
                return t("atr.firmware.invalidVersion");
            case RESPONSE_CODES.INVALID_JSON:
                return t("invalidJson");
        }
    }

    return "";
};
